/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Training - CamAPS FX',
    titleMeta: 'Wij bieden gratis een online-training aan voor CamAPS FX-gebruikers',
    descriptionMeta: 'Cambridge Diabetes Education Programme biedt een gratis gecertificeerde online-training aan voor personen met diabetes type 1, ouders en voogden, schoolpersoneel en diabetesbehandelaren.',
    keywords: 'camaps training, camaps fx training,  ',
    localeMeta: 'nl_NL',
    mainHeader: 'Zorgtraining',
    mainSubHeader: 'Ondersteun mensen die CamAPS FX gebruiken met training onder leiding van experts.',
    gettingStartedHeader: 'Aan de slag',
    step1Title: '<strong>Stap 1:</strong><br/>Download de app',
    step2Title: '<strong>Stap 2:</strong><br/>Maak een account aan',
    step3Title: '<strong>Stap 3:</strong><br/>Begin de essentiële in-app training',
    step4Title: '<strong>Stap 4:</strong><br/>Koppel met uw gekozen pomp en CGM (met goedkeuring van uw zorgteam) of verken de app met <strong>virtuele modus</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Gecertificeerde training',
    trainingHeader: 'Gecertificeerde training',
    trainingHeader_2: 'Voor diabetesbehandelaren',
    trainingHeader_3: 'Gebruikerstraining',
    trainingHeaderText: 'GRATIS online CamAPS FX-training, beschikbaar gesteld door het Cambridge Diabetes Education Programme (CDEP, het opleidingsprogramma van Cambridge op het gebied van diabetes).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'CDEP-training',
    getTrained: 'Volg nu een training!',
    trainingHeaderIat: 'CamAPS FX-training',
    trainingHeaderTextIat: 'Voltooi de essentiële in-app training voordat je de CamAPS FX-app gebruikt.',
    trainingSubHeaderOneIat: 'Aan de slag',
    trainingSubTextOneIat: 'Download de CamAPS FX-app. <br>Maak een account aan om met de training te beginnen.',
    trainingSubHeaderTwoIat: 'Hulp nodig bij het installeren van de app?',
    trainingParaTwoStartIat: 'Bezoek onze',
    trainingParaTwoEndIat: 'sectie voor begeleiding.',
    websiteLinkHeadingSupportIat: 'Ondersteuning',
    trainingSubHeaderThreeIat: 'Aanvullende bronnen',
    animationsYpsoPumpText: 'Animaties',
    animationsAndText: 'en',
    animationsDanaText: 'Animaties (Dana-pomp)',
    animationsFurtherText: 'Leer via stapsgewijze visuals.',
    webinarsText: 'Webinars',
    webinarsFurtherText: 'Bekijk sessies geleid door experts over het gebruik van de app.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
